import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageManagementComponent } from './page.management/page.management.component';
import { PageTransactionComponent } from './page.transaction/page.transaction.component';
import { PageIpMarketListingsComponent } from './page.ip.market.listings/page.ip.market.listings.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageIpMarketApplicationsComponent } from './page.ip.market.applications/page.ip.market.applications.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageIpMarketStatisticsComponent } from './page.ip.market.statistics/page.ip.market.statistics.component';
import { PageIpManagementOfficesComponent } from './page.ip.management.offices/page.ip.management.offices.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageIpManagementImportComponent } from './page.ip.management.import/page.ip.management.import.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageIpMarketMembersComponent } from './page.ip.market.members/page.ip.market.members.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageIpManagementRenewalsComponent } from './page.ip.management.renewals/page.ip.management.renewals.component';
import { PageIpMarketBuyerInquiriesComponent } from './page.ip.market.buyer.inquiries/page.ip.market.buyer.inquiries.component';
import { PageIpManagementConsultationsComponent } from './page.ip.management.consultations/page.ip.management.consultations.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageIpManagementQnaComponent } from './page.ip.management.qna/page.ip.management.qna.component';
import { PageIpManagementOfficesItemComponent } from './page.ip.management.offices.item/page.ip.management.offices.item.component';
import { PageIpMarketQnaComponent } from './page.ip.market.qna/page.ip.market.qna.component';
import { ComponentIpMarketDocumentsComponent } from './component.ip.market.documents/component.ip.market.documents.component';
import { PageIpManagementSendsComponent } from './page.ip.management.sends/page.ip.management.sends.component';
import { PageIpManagementMember_contentComponent } from './page.ip.management.member_content/page.ip.management.member_content.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';

import { ContactInputDirective } from "src/libs/portal/season/form-contact";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        ContactInputDirective,
        SafePipe,
        AppComponent,
        PortalSeasonTreeComponent,
        PageManagementComponent,
        PageTransactionComponent,
        PageIpMarketListingsComponent,
        LayoutSidebarComponent,
        PortalSeasonPaginationComponent,
        PageIpMarketApplicationsComponent,
        PageMypageComponent,
        PageIpMarketStatisticsComponent,
        PageIpManagementOfficesComponent,
        PortalSeasonLoadingDefaultComponent,
        PagePostsComponent,
        ComponentNavSidebarComponent,
        PageMembersComponent,
        PageIpManagementImportComponent,
        LayoutEmptyComponent,
        PortalSeasonModalComponent,
        PageIpMarketMembersComponent,
        PortalPostListComponent,
        PageIpManagementRenewalsComponent,
        PageIpMarketBuyerInquiriesComponent,
        PageIpManagementConsultationsComponent,
        PageDashboardComponent,
        PortalPostDetailComponent,
        PagePostsItemComponent,
        PageSignupComponent,
        PageAccessComponent,
        PortalSeasonFormDropdownComponent,
        PageIpManagementQnaComponent,
        PageIpManagementOfficesItemComponent,
        PageIpMarketQnaComponent,
        ComponentIpMarketDocumentsComponent,
        PageIpManagementSendsComponent,
        PageIpManagementMember_contentComponent,
        PortalSeasonLoadingSeasonComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }